import { render } from "./MainLayout.vue?vue&type=template&id=170bc3b7"
const script = {}

import "./MainLayout.vue?vue&type=style&index=0&id=170bc3b7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__